<div class="interaction_details col-12">
  @if (showUserSays(interaction)) {
    <div class="row mb-3" id="userInputWrapper">
      <label for="" class="col-3 col-form-label">
        User says
        @if (interaction.generative) {
          <span class="material-symbols-outlined generative_icon">stars_2</span>
        }
        @if (interaction.fallback) {
          <i class="fa-solid fa-circle-exclamation text-danger"></i>
        }
      </label>
      <div class="col-9">
        <div class="input_phrase">
          <div class="entity_pop_toggle" [ngbPopover]="popEntityContent" triggers="manual" #popEntity="ngbPopover" [popoverClass]="'popover_entity'" [placement]="'top'" [autoClose]="'outside'" [ngStyle]="{ left: entityPopOffset }"></div>
          @if (!uneditableView) {
            <div
              [attr.contenteditable]="interaction.isTrained == null && !forbiddenTraining && !!interaction.editedDfIntentName"
              class="form-control input_entity"
              [ngClass]="{ disabled: interaction.isTrained != null || forbiddenTraining || !interaction.editedDfIntentName }"
              [entitySelection]="interaction.editedDfEntityJson"
              [userQuery]="interaction.editedUserQuery"
              [updateEntities]="onUpdateEntities"
              (entitySelected)="togglePopEntity($event)"
              (input)="updateUserQuery($event.target)"
              >
              {{ interaction.editedUserQuery }}
            </div>
          }
          @if (uneditableView) {
            <div class="form-control input_entity disabled" [updateEntities]="onUpdateEntities" [entitySelection]="interaction.dfEntitiesJson" [userQuery]="interaction.userQuery">{{ interaction.userQuery }}</div>
          }
        </div>
      </div>
    </div>
  }
  @if (showEvent(interaction)) {
    <div class="row mb-3">
      <label for="interactionEventName" class="col-3 col-form-label">Event name</label>
      <div class="col-9 d-flex align-items-center">
        <span id="interactionEventName" class="interaction_context">
          {{ interaction.dfEventName }}
        </span>
      </div>
    </div>
  }
  <div class="row mb-3">
    <div class="offset-3 col-9">
      @if (showParameter && viewFilters.parameters) {
        <div class="table-responsive mt-3">
          <table class="table parameters_table" aria-describedby="Parameters Table">
            <thead>
              <tr>
                <th scope="col">Parameter Name</th>
                <th scope="col">Resolved Value</th>
                <th scope="col"></th>
              </tr>
            </thead>
            <tbody>
              @if (!uneditableView) {
                @for (parameter of interaction.editedDfEntityJson | keyvalue: orderBlank; track parameter; let i = $index) {
                  <tr>
                    <td [ngClass]="{ last_parameter: isLastParameter(interaction.editedDfEntityJson, i) }">
                      <span class="matches_{{ i }}">{{ parameter.key }}</span>
                    </td>
                    <td [ngClass]="{ last_parameter: isLastParameter(interaction.editedDfEntityJson, i) }">{{ parameter.value | json }}</td>
                    <td class="remove_parameter" [ngClass]="{ last_parameter: isLastParameter(interaction.editedDfEntityJson, i) }">
                      @if (interaction.isTrained == null && !forbiddenTraining) {
                        <button class="btn p-0" (click)="removeParameter(interaction, parameter.key)"><i class="fas fa-times" aria-hidden="true"></i></button>
                      }
                    </td>
                  </tr>
                }
              }
              @if (uneditableView) {
                @for (parameter of interaction.dfEntitiesJson | keyvalue: orderBlank; track parameter; let i = $index) {
                  <tr>
                    <td [ngClass]="{ last_parameter: isLastParameter(interaction.dfEntitiesJson, i) }">
                      <span class="matches_{{ i }}">{{ parameter.key }}</span>
                    </td>
                    <td colspan="2" [ngClass]="{ last_parameter: isLastParameter(interaction.dfEntitiesJson, i) }">{{ parameter.value | json }}</td>
                  </tr>
                }
              }
            </tbody>
          </table>
        </div>
      }
    </div>
  </div>
  @if (showIntent(interaction)) {
    <div class="row mb-3" id="intentWrapper">
      <label for="" class="col-3 col-form-label">Intent</label>
      <div class="col-9 d-flex align-items-center">
        <a
          id="trainingIntent"
          href="javascript:void(0)"
          class="edit_intent"
          [ngClass]="{ disable_intent_changing: !trainableIntent(interaction) }"
          [ngbPopover]="popIntentContent"
          triggers="manual"
          #popIntent="ngbPopover"
          [popoverClass]="'popover_intent'"
          [placement]="'right-top'"
          [autoClose]="'outside'"
          [disablePopover]="!trainableIntent(interaction) || forbiddenTraining"
          (click)="togglePopIntent()"
          >
          @if (!uneditableView) {
            <span>{{ !interaction.editedDfIntentName || interaction.editedDfIntentName === 'Default Welcome Intent' ? 'Select correct intent' : interaction.editedDfIntentName }}</span>
          }
          @if (uneditableView) {
            <span>{{ interaction.dfIntentName || 'No matched intent' }}</span>
          }
        </a>
      </div>
    </div>
  }

  @if (!interaction.generative) {
    <div class="row mb-3">
      <label for="interactionConfidence" class="col-3 col-form-label">Confidence</label>
      <div class="col-9 d-flex align-items-center">
        <p id="interactionConfidence" class="mb-0">{{ interaction.dfConfidence | number: '1.0-2' }}</p>
      </div>
    </div>
  }

  @if (interaction.generative && interaction.groundingScore) {
    <div class="row mb-3">
      <label for="interactionGrounding" class="col-3 col-form-label">Grounding</label>
      <div class="col-9 d-flex align-items-center">
        <p id="interactionGrounding" class="mb-0">{{ interaction.groundingScore }}</p>
      </div>
    </div>
  }

  @if (viewFilters.response) {
    <div class="row">
      <label for="interactionResponse" class="col-3 col-form-label">Response</label>
      <div id="interactionResponse" class="col-9">
        @for (message of getSplittedMessages(interaction.dfOutputMessage); track message) {
          <p class="mb-1" ellipsisText>{{ message }}</p>
        }
      </div>
    </div>
  }

  @if (interaction.dfPageName && viewFilters.page) {
    <div class="row mb-3">
      <label for="interactionPageName" class="col-3 col-form-label">Page</label>
      <div class="col-9 d-flex align-items-center">
        <p id="interactionPageName" class="mb-0">{{ interaction.dfPageName }}</p>
      </div>
    </div>
  }

  @if (interaction.dfFlowName && viewFilters.flow) {
    <div class="row mb-3">
      <label for="interactionFlowName" class="col-3 col-form-label">Flow</label>
      <div class="col-9 d-flex align-items-center">
        <p id="interactionFlowName" class="mb-0">{{ interaction.dfFlowName }}</p>
      </div>
    </div>
  }
</div>

<ng-template #popIntentContent>
  <div id="intentPopover">
    <form #searchIntentForm="ngForm" novalidate>
      <input type="text" name="intentFilter" class="form-control" [(ngModel)]="intentFilter" #ctrl="ngModel" />
    </form>

    <ul class="list-unstyled popover_list">
      @for (intent of intents | fullTextSearch: intentFilter:'name'; track intent) {
        <li>
          <a href="javascript:void(0)" (click)="setIntent(intent)">{{ intent.name }}</a>
        </li>
      }
    </ul>
  </div>
</ng-template>

<ng-template #popEntityContent let-entityEvent="$event">
  @if (!entities.length) {
    <div role="alert" class="alert alert-warning mb-0">No entity for this Intent</div>
  }

  @if (entities.length) {
    <form novalidate>
      <input type="text" name="entityFitler" class="form-control" [(ngModel)]="entityFilter" #ctrl="ngModel" />
    </form>
    <ul class="list-unstyled entities_list">
      @for (entity of entities | fullTextSearch: entityFilter: 'id'; track $index) {
        <li>
          <a href="javascript:void(0)" (click)="setEntity(entity.id, entityEvent)">{{ entity.id }}</a>
        </li>
      }
    </ul>
  }
</ng-template>
